import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Reusable summary footer displaying two right-aligned total lines.
 * Used by Additions/Deductions, Taxes, and other payroll mapping tables.
 *
 * @param {Array<{ label: string, value: string|number }>} items - Array of { label, value } pairs to display
 */
const TwoItemSummaryFooter = React.memo(function TwoItemSummaryFooter({ items = [] }) {
    return (
        <Box display="flex" flexDirection="column" alignItems="flex-end" mt={1} pr={2} gap={0.5}>
            {items.map((item, idx) => (
                <Typography key={idx} fontWeight={600} fontSize={11}>
                    {item.label}: {item.value}
                </Typography>
            ))}
        </Box>
    );
});

export default TwoItemSummaryFooter;
